import type { ReactNode } from 'react';
import type { Role } from '@dfx-transfer/shared-types';
import { useTransferUser } from '../auth/useTransferUser';

interface Props {
  allow: readonly Role[];
  children: ReactNode;
  fallback?: ReactNode;
}

export function RoleGuard({ allow, children, fallback }: Props) {
  const { user, isLoading } = useTransferUser();
  if (isLoading) return <div>Loading…</div>;
  if (!user || !allow.includes(user.role)) {
    return (
      fallback ?? (
        <div className="rounded border border-[color:var(--color-border)] p-6 text-[color:var(--color-text-secondary)]">
          You don't have access to this page.
        </div>
      )
    );
  }
  return <>{children}</>;
}
